// Module
var code = `<li><button value name="link"> </button></li>`;
// Exports
export default code;